module.exports = __webpack_public_path__ + "static/media/pbl-logo.c0c4d7d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pbl-logo.svg
// module id = 796
// module chunks = 0